import React, {Fragment, SyntheticEvent, useEffect, useState} from "react";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import {v4} from "uuid";
import {Checkbox, FormLabel, ListItemText, OutlinedInput} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import charcreate from "../../_helper/charcreate";
import {useSignals} from "@preact/signals-react/runtime";
import {s_char, s_char_skills, s_char_talents} from "../../_signals/s_char";
import {ICharSkill} from "../../_interfaces/ICharSkill";
import {IRollerRoll} from "../../_interfaces/IRoller";
import {SkillsCreate, SkillsDelete, SkillsUpdate} from "../../_api/BESkills";
import {LPChangesCreate} from "../../_api/BELPChanges";
import {ICharLPChanges} from "../../_interfaces/ICharLPChanges";
import updChar from "../../_sig_api/updChar";
import {styled} from "@mui/material/styles";
import {InfoTalentSkillSubscriber} from "../../_helper/InfoTalentSkillBehave";
import {TalentSkillSubscriber} from "../../_helper/DataBehaves";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import ClearIcon from "@mui/icons-material/Clear";
import {SaveAlt} from "@mui/icons-material";
import getSkillDefines from "./getSkillDefines";
import {s_app_sl} from "../../_signals/s_app";

const Item = styled(Paper)(({theme}) => ({
    backgroundColor: '#fff', ...theme.typography.body2, padding: 4, height: '100%', textAlign: 'center', color: '#000',
}));

interface IProp {
    edit: string,
    isOpen: (id: string) => void
}
function SkillsEdit({edit,isOpen}:IProp) {
    useSignals()

    const [skill, setSkill] = useState<ICharSkill|null>(null)

    const mod_rank = [...Array(7).keys()];

    useEffect(() => {
        let fd = s_char_skills.value.find(d => d.id === edit);
        if (fd) {
            fd = getSkillDefines(fd)
            setSkill(fd)
        }
        else setSkill(null)
    }, [edit])

    const handleInfoPopOpen = (skillname: string, e: SyntheticEvent) => {
        const skill = TalentSkillSubscriber.value.find(s => s.hasOwnProperty('lps_skill') && s.name === skillname)
        if (skill) {
            InfoTalentSkillSubscriber.next({popOpen: true, popEl: e.currentTarget, pop: skill})
        }
    }

    const raise = () => {

        let skills = s_char_skills.value
        const sl = s_app_sl.value


        let lp_current = s_char.value.lp_current;
        const nsc = s_char.value.nsc;

        const no_lp = nsc && sl;

        if (nsc && !sl) return;

        let update = false;
        skills = skills.map(t => {
            if (t.id === skill?.id) {
                const nextStep = t.step + 1;
                let lpstart = t.lpstart;
                let cost = charcreate.raiseCost(lpstart, nextStep);

                if (no_lp) {
                    t.step = nextStep;
                    update = true;
                } else if (cost > 0) {
                    if (cost < lp_current) {
                        if (window.confirm('Steigerung Fertigkeit ' + t.name + '\nauf Stufe: ' + nextStep+'\nKosten: ' + cost + '\nAktuelle Legendenpunkte: '+lp_current)) {
                            lp_current = lp_current - cost;
                            updChar([{k: 'lp_current', v: lp_current}])

                            const time = new Date().toISOString();
                            const changes: ICharLPChanges = {
                                id: v4(),
                                cid: s_char.value.id,
                                ts: time,
                                entry: '-' + cost + ' Steigerung Ferigkeit ' + t.name + ' auf ' + nextStep
                            };
                            LPChangesCreate(changes)

                            t.step = nextStep;

                            SkillsUpdate(t)
                            update = true;
                        }
                    } else alert('zu wenig lp');
                } else alert('lp kosten fehler');
            }
            return t;
        });

        if (update) s_char_skills.value = skills
    }

    const canRaise = () => {
        if (!skill)return false
        return charcreate.raiseCost(skill.lpstart, skill.step + 1) <= s_char.value.lp_current
    }

    const handleDefineSingleChange = (event, skillid) => {
        const {
            target: {value},
        } = event;

        let skills = s_char_skills.value

        skills = skills.map(t => {
            if (t.id === skillid) {
                if (!t.define || t.define.length === 0) {
                    t.define = [value];
                    SkillsUpdate(t);
                    s_char_skills.value = skills
                } else alert('fertigkeit nicht änderbar')
            }
            return t;
        });

    };

    const handleDefineMultiChange = (event, skillid) => {
        const {
            target: {value},
        } = event;

        let skills = s_char_skills.value

        const values = typeof value === 'string' ? value.split(',') : value;

        let update = false
        skills = skills.map(t => {
            if (t.id === skillid) {
                if (t.step >= values.length) {
                    t.define = values;
                    SkillsUpdate(t);
                    update = true
                } else alert('Fertigkeit zu niedrig')
            }
            return t;
        });
        if (update) s_char_skills.value = skills

    };


    return <Fragment>
        <Dialog open={edit !== ''}>
            <DialogContent>
                <div key={'dedc1'}>
                    Fertigkeit: {skill?.name}
                </div>
                <div key={'dedc2'}>
                    Stufe: {skill?.step}
                </div>
                <div key={'dedc3'}>
                    {skill?.hasOwnProperty('define_multi') && skill?.define_multi!.length > 0 ?
                        <FormControl>
                            <Select
                                multiple
                                value={skill.define}
                                onChange={(event) => handleDefineMultiChange(event, skill.id)}
                                input={<OutlinedInput label="Tag"/>}
                                renderValue={(selected) => selected.join(', ')}
                            >
                                {skill.define_multi?.map((name) => (
                                    <MenuItem key={name} value={name}>
                                        <Checkbox
                                            disabled={
                                                skill.define.indexOf(name) > -1
                                            }
                                            checked={
                                                skill.define.indexOf(name) > -1
                                            }/>
                                        <ListItemText primary={name}/>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        :
                        null
                    }
                    {skill?.hasOwnProperty('define_single') && skill?.define_single!.length > 0 ?
                        skill.define.length === 0 ?
                            <FormControl>
                                <Select
                                    value={skill.define}
                                    onChange={(event) => handleDefineSingleChange(event, skill.id)}
                                >
                                    {skill.define_single?.map((name) => (
                                        <MenuItem key={name} value={name}>{name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            :
                            <span>{skill.define}</span>
                        :
                        null
                    }
                </div>
                {skill?.lpstart ? <div key={'dedc4'}>
                    Kosten nächste
                    Stufe: {charcreate.raiseCost(skill?.lpstart, (skill?.step ? skill.step + 1 : 0))}
                </div> : null}
                <div key={'dedc5'}>
                    {!canRaise()?'Zuwenig':'Verfügbare'} Legendenpunkte: {s_char.value.lp_current}
                </div>
            </DialogContent>
            <DialogActions>
                <Button disabled={!canRaise()}
                        onClick={() => raise()}><ArrowUpwardIcon/></Button>
                <Button onClick={() => isOpen('')}><ClearIcon/></Button>
            </DialogActions>
        </Dialog>
    </Fragment>
}

export default SkillsEdit;
